<template>
	<div>
		<a-modal title="选择次卡" :width="480" :visible="visible"  @cancel="handleCancel">
			<template slot="footer" >
				<a-button  key="back"  @click="handleCancel">
					取消
				</a-button>
				<a-button  key="submit" type="primary" @click="onSubmit" :loading="confirmLoading">
					确定赠送
				</a-button>
			</template>
			<a-spin :spinning="loading">
				<div>
					<div class="flex center">
						<a-input-search placeholder="搜索次卡" v-model="search.keyword" style="width: 420px" @search="onSearch" />
					</div>
					<div v-if="datas.length>0" class="flex wrap center mt20">
						<div class="choose-once-card-item" v-for="(item,index) in datas">
							<div class="flex alcenter space">
								<div class="flex alcenter">
									<img :src="item.cover_img" class="choose-once-card-item-cover-img"/>
									<div class="ml15">
										<div class="ft14 ftw600 cl-black text-over">{{item.name}}</div>
										<div class="flex alcenter mt15">
											<div class="ft12 ftw400 cl-info">有效期：</div>
											<div class="ft12 ftw400 cl-balck">{{item.valid_time_format}}</div>
										</div>
										
										<div class="flex alcenter mt20" v-if="item.is_flash_sale==1 && item.is_flash_sale_expire==0">
											<div class="ft12 ftw400 cl-price ">秒杀价：¥</div>
											<div class="ft16 ftwblod cl-price">{{item.flash_price}}</div>
										</div>
										<div class="flex alcenter mt20" v-else>
											<div class="ft12 ftw400 cl-price ">¥</div>
											<div class="ft16 ftwblod cl-price">{{item.price}}</div>
										</div>
										
									</div>
								</div>
								
								<div>
									<div class="balance-choose-couopon-item-selected" @click="removeSelectId(index)" v-if="select_ids.indexOf(item.once_card_id)!=-1">
										<a-icon type="check" class="cl-w"/>
									</div>
									
									<div class="balance-choose-couopon-item-select" v-else @click="addSelectId(index)">
										
									</div>
								</div>
							</div>
							
							<img v-if="item.is_flash_sale==1 && item.is_flash_sale_expire==0" class="choose-once-card-item-flash-sale-tag" src="../../../../../assets/image/label_miaosha@3x.png"/>
							<div class="choose-once-card-item-flash-sale-djs" v-if="item.is_flash_sale==1 && item.is_flash_sale_expire==0">
								<div class="flex alcenter">
									<div class="ft10 ftw400 cl-w">距结束：</div>
									<time-countdown :t="item.flash_sale_djs" type="text" size="ft12 ftwbold cl-w"></time-countdown>
								</div>
							</div>
						</div>
					</div>
				
					<div v-else class="flex center mt20">
						<a-empty/>
					</div>
					<div class="flex center mt20">
						<a-pagination @change="pageChange" :total="pagination.total" v-model="pagination.current" :pageSize="pagination.pageSize" show-less-items />
					</div>
				</div>
			</a-spin>
		</a-modal>
	</div>
</template>

<script>
	import {listMixin} from '../../../../../common/mixin/list.js';
	import timeCountdown from '../../../../../components/time/countdown.vue';
	export default {
		mixins:[listMixin],
		components:{
			
			timeCountdown,
		},
		props: {
			visible:{
				type:Boolean,
				default:false,
			},
			value:{
				type:Array,
				default:function(){
					return new Array;
				},
			},
		},
		data() {
			return {
				loading: false,
				confirmLoading: false,
				setPriceLoading:false,
				select_ids:[],
				search:{
					keyword:'',
				},
				pagination:{
					total:0,
					pageSize:4,
					current:1,
				},
				datas:[],
				select_id:1,
			}
		},
		created() {
			for(var a in this.value){
				this.select_ids.push(this.value[a]);
			}
		},
		methods: {
			
			getLists(){
				if (this.loading == true) return;
				this.loading = true;
				this.$http.api('admin/chooseOnceCard', {
					limit: this.pagination.pageSize,
					page: this.pagination.current,
					member_id:this.member_id,
				}).then(res => {
					this.pagination.total = res.total;
					this.datas = res.list;
					this.loading = false;
				}).catch(res => {
					this.loading = false;
				})
			},
			
			onSearch(){
				this.pagination.current=1;
				this.getLists();
			},
	
			/**
			 * 选中
			 * @param {Object} index
			 */
			addSelectId(index) {
				if (this.select_ids.indexOf(this.datas[index].once_card_id) != -1) {
					this.$message.error("您已经选择过这个了");
				}
				this.select_ids.push(this.datas[index].once_card_id);
				console.log(this.select_ids);
				console.log(this.value);
			},
			
			/**
			 * 取消选择
			 * @param {Object} index
			 */
			removeSelectId(index) {
				let startIndex = this.select_ids.indexOf(this.datas[index].once_card_id);
				if (startIndex == -1) {
					this.$message.error("您已经取消过这个了");
				}
				this.select_ids.splice(startIndex, 1);
			},
			
			/**
			 * 取消弹窗
			 */
			handleCancel() {
				this.$emit("cancel");
			},
				
			/**
			 * 提交数据
			 */
			onSubmit() {
				if(this.confirmLoading==true) return;
				this.confirmLoading=true;
				let value = this.select_ids;
				this.$emit('input',value);
				this.confirmLoading=false;
				this.$emit("ok");
			},
			
		}
	}
</script>

<style>
	.choose-once-card-item{
		width: 420px;
		height: 122px;
		background: #FFFFFF;
		border-radius: 8px;
		border: 1px solid #EBEDF5;
		margin-bottom: 10px;
		padding: 15px;
		position: relative;
		line-height: 1;
	}
	
	.choose-once-card-item-cover-img{
		width: 120px;
		height: 90px;
		border-radius: 4px;
	}
	
	.choose-once-card-item-flash-sale-tag{
		width: 48px;
		height: 48px;
		position: absolute;
		top:0;
		left:0;
	}
	
	.choose-once-card-item-flash-sale-djs{
		
		background: linear-gradient(270deg, #FF6600 0%, #FFAA00 100%);
		border-radius: 2px;
		opacity: 0.93;
		line-height: 1;
		padding: 1px 4px;
		
		position: absolute;
		bottom: 20px;
		left: 15px;
	}
</style>
